import { render, staticRenderFns } from "./TextContent.vue?vue&type=template&id=268f2962&scoped=true"
import script from "./TextContent.vue?vue&type=script&lang=js"
export * from "./TextContent.vue?vue&type=script&lang=js"
import style0 from "./TextContent.vue?vue&type=style&index=0&id=268f2962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268f2962",
  null
  
)

export default component.exports